import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setBackButtonUrl } from "../uiSlice";
import { setupAppPageBodyBackground } from "../game/gameStageBackground";
import "../fonts/breuer-headline.css";
import "./begin.css";

import beginDesk from "../img/begin_desk.jpg";
import beginMob from "../img/begin_mob.jpg";
import letterBg from "../img/begin_letter.png";
import greenBtn from "../img/green_button.png";

function Begin() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const [nextLoading, setNextLoading] = useState(false);

  useEffect(() => {
    dispatch(setBackButtonUrl("/rules"));
  }, [dispatch]);

  useEffect(() => {
    return setupAppPageBodyBackground(document.body, {
      deskForeground: beginDesk,
      mobForeground: beginMob,
    });
  }, []);

  const handleLetsBegin = useCallback(
    (e) => {
      e.preventDefault();
      if (!user || nextLoading) return;
      setNextLoading(true);
      navigate("/hall-1", { replace: true });
    },
    [user, nextLoading, navigate]
  );

  return (
    <div className="begin-page">
      <div className="begin-layout">
        <div
          className="begin-letter"
          style={{ backgroundImage: `url(${letterBg})` }}
        >
          <div className="begin-letter__inner">
            <h1 className="begin-letter__title">THE MEDALS HAVE BEEN MIXED UP!</h1>
            <div className="begin-letter__rule" aria-hidden="true">
              <span className="begin-letter__star">★</span>
            </div>
            <div className="begin-letter__body">
              <p>The medals have been placed in the wrong categories.</p>
              <span className="begin-letter__sep" aria-hidden="true">
                ★
              </span>
              <p>
                Restore the Hall of Champions by placing every medal in its
                correct exhibition.
              </p>
              <span className="begin-letter__sep" aria-hidden="true">
                ★
              </span>
              <p>
                Only then will the legacy of India’s greatest athletes be
                preserved.
              </p>
            </div>
            <button
              type="button"
              className="begin-start-btn"
              disabled={nextLoading || !user}
              onClick={handleLetsBegin}
              style={{ backgroundImage: `url(${greenBtn})` }}
            >
              {nextLoading ? "LOADING…" : "LET'S BEGIN"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Begin;
